import React from "react"; // eslint-disable-line no-unused-vars

function Card({ title, text, icon }) {
  return (
    <div className="col-md-6 col-lg-4">
      <div className="modern-card service-card h-100">
        <div className="card-icon-wrapper">
          <div className="service-icon" aria-hidden="true">{icon}</div>
        </div>
        <div className="card-body d-flex flex-column">
          <h5 className="card-title service-title">{title}</h5>
          <p className="card-text service-text flex-grow-1">{text}</p>
          <div className="mt-auto">
            <a
              href="#contact"
              className="btn modern-btn-outline w-100"
              aria-label={`Learn more about ${title}`}
            >
              Learn More &rarr;
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Card;
